<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des codes OAG</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="structure" slot-scope="props">
           {{ props.row.structure.libelle }}
          </div>
          <div slot="action" slot-scope="props">
           <span v-if="canAccess(rules.MANAGE_OAP_OAG)">
              <i class="fa fa-pencil mr-2 text-primary clickable" @click="edit( props.row.id)"></i>
           </span>
            <span v-if="canAccess(rules.MANAGE_OAP_OAG)">
              <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row)"></i>
            </span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button v-if="canAccess(rules.MANAGE_OAP_OAG)"
          type="button"
          @click="create()"
          class="pull-right"
          size="md"
          variant="primary">
          <i class="fa fa-plus"></i> Ajouter un OAG
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from '@/utils/auth';
  import {rules, hasRule} from '@/utils/rulesHelper';
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    data() {
      return {
        rules: rules,
        columns: ['code', 'libelle', 'libelle_technique', 'structure', 'action'],
        items: [],
        options: {
          headings: {
            code: "Code",
            libelle: "Libellé",
            libelle_technique: "Libellé technique",
            structure: "Structure"
          },
          sortable: ["code","libelle", 'structure'],
          filterable: ["code","libelle", 'structure'],
          perPage: 10,
          perPageValues: [10, 20, 25],
          texts: {filterPlaceholder: "Code, Libellé, Structure"},
          orderBy: {column: "code"},
        },
      };
    },
    created() {
      this.all()
    },
    methods: {
      canAccess(rule) {
        return hasRule(rule)
      },
      all() {
        let self = this;
        this.$axios
          .get("/referentielClient/oag")
          .then(response => {
            this.items = response.data.oags;
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      create(){
        this.$router.push({path: "/administration/gestionOapOag/oag/create"});
      },
      edit(oagId) {
          this.$router.push({path: "/administration/gestionOapOag/oag/edit/" + oagId});
      },
      destroy(oag) {
        let self = this;
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer ce code OAG ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("IS_LOADING", true);
              this.$axios
                .post("/administration/oag/delete/" + oag.id)
                .then(() => {
                  this.$store.commit("IS_LOADING", false);
                  this.$swal({
                    position: "top",
                    type: "success",
                    title: "Suppression avec succès",
                    text: "L'OAg "+oag.code+" a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch((error) => {
                  self.$store.commit("IS_LOADING", false);
                  self.handleError(error);
                });
            }
          });
      },
      handleError(error) {
        console.log(error)
        
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit de gérer cet OAG';
        } else if (!isEmpty(error) && error.response && (error.response.status === 406 || error.response.status === 424)) {
          text = error.response.data.message;
        } else if (error.response && error.response.status === 404 && this != undefined) {
          this.$router.push({path: '/administration/gestionOapOag/oaG'})
          text: 'L\'OAG avec l\'id ' + this.$route.params.id + ' n\'existe pas';
        }
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: text,
          showConfirmButton: false,
          timer: 5000
        });
      },
    }
  };
</script>